let initialState = {
  contents: {
    0: {
      data: []
    },
    1: {
      data: []
    },
    2: {
      data: []
    },
    3: {
      data: []
    },
    4: {
      data: []
    }
  }
};

const ContentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CONTENTS_PENDING':
      return {
        ...state,
        pending: true,
        error: false,
      };

    case 'GET_CONTENTS_SUCCESS':
      return {
        ...state,
        pending: false,
        error: false,
        contents:
          {
            ...state.contents,
            [action.tag_index]: {
              data: action.data,
              next_token: action.next_token
            }
          },
      };
    case 'APPEND_CONTENTS_SUCCESS':
      return {
        ...state,
        pending: false,
        error: false,
        contents:
          {
            ...state.contents,
            [action.tag_index]: {
              data: [
                ...state.contents[action.tag_index].data,
                ...action.data
              ],
              next_token: action.next_token
            }
          },

      };
    case 'GET_CONTENTS_ERROR':
      return {
        ...state,
        pending: false,
        error: true
      };

    default:
      return state
  }
};

export default ContentsReducer
